// components/LoadingDialog.jsx
import React from "react";
import {
    Dialog,
    DialogContent,
    DialogTitle,
    CircularProgress,
    Typography,
    Box
} from "@mui/material";

const SizeSoftXLoadingProcess = ({ open, message = "Procesando, por favor espere..." }) => {
    return (
        <Dialog open={open} PaperProps={{ sx: { textAlign: "center", p: 3 } }}>
            <DialogTitle sx={{ fontWeight: 'bold' }}>Cargando</DialogTitle>
            <DialogContent>
                <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" gap={2}>
                    <CircularProgress />
                    <Typography>{message}</Typography>
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default SizeSoftXLoadingProcess;
